import { useMatch } from "react-router-dom";
import UserModel from "../../Models/User/UserModel";
import { useEffect, useState } from "react";
import BotUser from "../../Models/Parse/BotUser";
import Parse from "parse";
import { config } from "@fortawesome/fontawesome-svg-core";
import { SwivlChat } from "@swivl/swivl-chat-typescript";
import { ServerEnvironment } from "@swivl/swivl-lib";
import { Config } from "../../Config/Config";
import "@swivl/swivl-chat-typescript/build/bundle.css"
import "./TranscriptView.scss"
import { BotUserModel } from "../../Models/BotUser/BotUser.Model";
import '../Conversations/ConversationsViewChatStyles.scss';
import { NavBar } from "../../Models/NavBar/NavBar.Model";
import BotUserTranscriptDetails from "./BotUserDetails/BotUserTranscriptDetails";
import RenewButton from "./RenewButton/RenewButton";
import { Spinner } from "../../Components/Spinner/Spinner";

enum TranscriptStatus {
    Loading,
    Error,
    InvalidBotUserId,
    InvalidUserPermissions,
    Expired,
    Valid
}



export default function TranscriptView() {
    const match = useMatch("/transcript/:botUserId");
    const botUserId = match?.params.botUserId;
    const {user, isLoadingUser} = UserModel.useState();
    const [botUser, setBotUser] = useState<BotUser | undefined>(undefined);
    const [messages, setMessages] = useState<any[]>([]);
    const [transcriptStatus, setTranscriptStatus] = useState<TranscriptStatus>(TranscriptStatus.Loading);
    useEffect(() => {
        // if (bot.hasEscalations)
        NavBar.set(
          null,
          <NavBar.Component.Title title={"Conversation Transcript"} />,
          <RenewButton botUser={botUser} />,
          "Conversations");
      }, [user, botUser])

      useEffect(() => {
        if (!botUserId) {
            return;
        }
        if (transcriptStatus === TranscriptStatus.Valid) {
            
            Parse.Cloud.run("getAllMessages", {botUserId: botUserId}).then((messages) => {
            
            setMessages(messages);
        
        }).catch((e) => {
            
        })
        }
        }, [botUserId, transcriptStatus])


    useEffect(() => {
        
        if (!botUserId) {
            setTranscriptStatus(TranscriptStatus.InvalidBotUserId);
            return;
        }


        const fetchData = async () => {
            if (isLoadingUser) {
                return; 
            }
            let _botUser: BotUser = await BotUser.getById(botUserId);
            if (!_botUser) {
                setTranscriptStatus(TranscriptStatus.InvalidBotUserId);
                return;
            }
            if (_botUser.get("transcriptAccessExpires")  && _botUser.get("transcriptAccessExpires") > new Date()) {
                
                
            setTranscriptStatus(TranscriptStatus.Valid);
            setBotUser(_botUser);
            return; 
            }


            if (user) {
                if (!UserModel.hasPermissionsForBot(_botUser.get("bot").id)) {
                    setTranscriptStatus(TranscriptStatus.InvalidUserPermissions);
                    return;
                }
                setTranscriptStatus(TranscriptStatus.Valid);
                setBotUser(_botUser);
                return; 
            } else {
                if (_botUser.get("transcriptAccessExpires") < new Date()) {
                    setTranscriptStatus(TranscriptStatus.Expired);
                    return;
                }
                setTranscriptStatus(TranscriptStatus.Valid);
                setBotUser(_botUser);
                return; 
            }

            

            

        }
        fetchData().catch((e) => {
            
            setTranscriptStatus(TranscriptStatus.Error);
        })
    }, [botUserId, user, isLoadingUser])


    
    if (messages.length && botUser && transcriptStatus === TranscriptStatus.Valid) {
        const config = {"botId":botUser.get("bot").id,"server":Config.SERVER_HOSTNAME,"startOnQuest":null,"position":"bottom-right","startConversationClosed":false,"startOpen":true,"loadPastMessages":false,"avatarURL":"https://swivl-uploads-production.s3.amazonaws.com/6c08334665295793d46533dd870a8bb5_avatar.png","showAvatarInHeader":false,"showAvatarWithTimestamp":true,"headerText":"Chat with <b>Storage R Us</b>","primaryFont":"'Poppins', sans-serif;","secondaryFont":"'Poppins', sans-serif;","loadPastMessagesColor":"#DAD3D0","loadPastMessagesHoverColor":"#C3BCB9","loadPastMessagesActiveColor":"#A8A4A2","loadPastMessagesSpinnerFill":"#00CABE","headerBackground":"#ffffff","headerColor":"#000000","bodyBackground":"#ffffff","userBubbleBackground":"#ECECEC","userBubbleColor":"#000000","botBubbleBackground":"#ECECEC","botBubbleColor":"#000000","timestampColor":"#949494","formBackground":"#FFFFFF","formColor":"#000000","sendButtonBackground":"#0c1689","sendButtonColor":"#FFFFFF","sendButtonHoverBackground":"#2633ba","sendButtonHoverColor":"#FFFFFF","sendButtonActiveBackground":"#0c1689","sendButtonActiveColor":"#FFFFFF","primaryButtonBackground":"#d0021b","primaryButtonColor":"#FFFFFF","primaryButtonHoverBackground":"#0c1689","primaryButtonHoverColor":"#FFFFFF","primaryButtonActiveBackground":"#0c1689","primaryButtonActiveColor":"#FFFFFF","secondaryButtonBackground":"#0c1689","secondaryButtonColor":"#FFFFFF","secondaryButtonHoverBackground":"#fd8102","secondaryButtonHoverColor":"#FFFFFF","secondaryButtonActiveBackground":"#0c1689","secondaryButtonActiveColor":"#FFFFFF","tertiaryButtonBackground":"#24488d","tertiaryButtonColor":"#FFFFFF","tertiaryButtonHoverBackground":"#ff3366","tertiaryButtonHoverColor":"#FFFFFF","tertiaryButtonActiveBackground":"#24488d","tertiaryButtonActiveColor":"#FFFFFF","ctaStartOnQuest":"9LC7DdWwoE","showCTA":false,"ctaTitle":"Chucks Cool CTA","ctaImageURL":"https://swivl-cdn.s3-us-west-1.amazonaws.com/test%402x.png","ctaBody":"This was made in the embed builder.","ctaDelay":"5","ctaAnalytics":null,"collapsedStyle":"dot","dotText":"How can I help?","showCloseButton":true,"showAvatar":true,"questSlug":"","linkColor":"#fd8102","linkHoverColor":"#0c1689","dotDesktopLeftOffset":155,"bodyDesktopLeftOffset":155,"preloadVariables":{"StoreBrandId":"Chuck1"}}

        return <div className="TranscriptView PageThreeColumn">
                <div className="column usersColoumn">
                    <div className="botUser">{BotUserModel.displayNameForUser(botUser)}</div>
    </div>
    <div className="column">
        <div className="chatRow botUserConversation">
    <SwivlChat
        key={botUser.id}
                              hideForm={true}
                              isReadOnly={true}
                              canTakeOver={false}
                              parentControlsStart={false}
                              isConversationTakenOver={false}

                              config={config as unknown as any}
                              auth={null}
                              thirdPartyId={undefined}
                              generateCSS={true}
                              isOpen={true}
                              preloadedMessages={messages}
                              server={Config.SERVER_HOSTNAME}
                              isMobile={false}
                              commandCallback={(command)=>{  }} 
                              // notificationsServer={"swivl-notifications.ngrok.io"}
                              environment={ServerEnvironment.PRODUCTION}
                              />


</div>
<div className="chatForm">
This is the transcript for a single conversation.<br/>
To interact with this customer, navigate to the Conversations section.

    
</div>

    </div>
    <div className="column">
 
    <BotUserTranscriptDetails item={botUser} bot={botUser.get("bot")} />


    </div>
  </div>;


    }


    return <div className="TranscriptView PageThreeColumn">
                <div className="column usersColoumn">

    </div>
    <div className="column">
        <div className="chatRow botUserConversation">
    {(transcriptStatus === TranscriptStatus.InvalidUserPermissions || transcriptStatus === TranscriptStatus.Expired) && 
    <div className="transcriptError">
    <div className="icon">⌛️</div>
    <div className="title">This link has expired</div>
    <div className="message">Contact your manager for a new link</div>

        </div>
        }

{(transcriptStatus === TranscriptStatus.Error) && 
    <div className="transcriptError">
    <div className="icon">😞</div>
    <div className="message">There was an error loading this conversation</div>

        </div>
        }
    

</div>
<div className="chatForm">
{(transcriptStatus === TranscriptStatus.Loading) && 
<Spinner />
}
</div>

    </div>
    <div className="column">
 



    </div>
  </div>;


    return <div className="TranscriptView">
    </div>
}